import { get, isFunction } from 'lodash-es'
import { isPromise } from './bits'

import envRaw from './env-raw'

import rawMed from 'median'
import rawAvg from 'array-avg'
const med = (arr) => Math.round(rawMed(arr))
const avg = (arr) => Math.round(rawAvg(arr))
const max = (arr) => Math.max(...arr)
const min = (arr) => Math.min(...arr)

export default envRaw.useProfile ? profile : fakeProfile

function fakeProfile(tag, action) {
  return isFunction(tag)
    ? tag
    : action
}

function profile(tag, action) {
  if (isFunction(tag)) {
    action = tag
    tag = get(action, '_handlerTag', get(action, 'name', 'unknown'))
  }

  const last5 = LimitArray(5)
  const last10 = LimitArray(10)
  const last20 = LimitArray(20)
  let count = 0

  function serveDiff(diff) {
    last5.add(diff)
    last10.add(diff)
    last20.add(diff)
    count++

    if ((count % 5) === 0) {
      console.debug(`${tag} profile:\
        \n\t  last 5: med - ${med(last5)}\
        \n\t          avg - ${avg(last5)}\
        \n\t          max - ${max(last5)}\
        \n\t          min - ${min(last5)}\
        \n\t last 10: med - ${med(last10)}\
        \n\t          avg - ${avg(last10)}\
        \n\t          max - ${max(last10)}\
        \n\t          min - ${min(last10)}\
        \n\t last 20: med - ${med(last20)}\
        \n\t          avg - ${avg(last20)}\
        \n\t          max - ${max(last20)}\
        \n\t          min - ${min(last20)}`)
    }
  }

  function profile_wrapper(...args) {
    const run = Date.now()
    const res = action(...args)
    if (!isPromise(res)) {
      serveDiff(Date.now() - run)
      return res
    } else {
      return res.finally(() => serveDiff(Date.now() - run))
    }
  }

  return profile_wrapper
}

function LimitArray(limit) {
  const arr = new Array(limit)
  let count = 0
  arr.add = (value) => {
    arr[count] = value
    count++
    if (count === limit) count = 0
  }
  return arr
}
